export default "__VITE_ASSET__BmC2CdfU__"